<template>
  <main>
    <section v-if="loading" class="container mt-5 ">
      <div class="d-flex w-100">
        <b-skeleton class="w-100" height="300px"></b-skeleton>
      </div>
      <div class="content-sales-campaign-grid mt-5">
        <b-skeleton-img
          class="w-100 "
          height="300px"
          v-for="product in 24"
          :key="product"
        ></b-skeleton-img>
      </div>
    </section>
    <section v-else-if="flashes" class="container content-sales-campaign">
      <picture class="image-campaign">
        <source media="(max-width:648px)" :srcset="flashes.mobile_image.url" />
        <img :src="flashes.image.url" alt="" />
      </picture>
      <div>
        <transition name="fade">
          <div v-if="nextpage" class="loading-container">
            <Loading />
          </div>
        </transition>
        <div class="content-sales-campaign-grid ">
          <template
            v-if="
              flashes.products &&
                flashes.products.data &&
                flashes.products.data.length
            "
          >
            <Product
              them="blackFriday"
              v-for="(product, index) in flashes.products.data"
              :key="product.id ? product.id : index"
              class="w-100 "
              :product="product"
            />
          </template>
        </div>
      </div>
      <section
        v-if="
          flashes.products &&
            flashes.products.data &&
            flashes.products.data.length
        "
        class="list-pagination weblog-list-pagination text-center my-4 py-2 fontsize-medium"
      >
        <pagination
          :router="true"
          :limit="3"
          :data="flashes.products"
          @pagination-change-page="changePage"
          class="justify-content-center"
        >
          <span slot="prev-nav">
            <svg
              class="page-arrow mb-2"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="22"
              height="22"
              viewBox="0 0 226 226"
              style="fill: #000000"
            >
              <g
                fill="none"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray=""
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style="mix-blend-mode: normal"
              >
                <path d="M0,226v-226h226v226z" fill="none"></path>
                <g fill="#b2b2b2">
                  <path
                    d="M82.80781,169.67656c1.05938,1.05937 2.47187,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906l52.96875,-52.96875c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-52.96875,-52.96875c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0c-2.11875,2.11875 -2.11875,5.47344 0,7.41563l49.26094,49.26094l-49.26094,49.26094c-2.11875,2.11875 -2.11875,5.29688 0,7.41562z"
                  ></path>
                </g>
              </g>
            </svg>
          </span>
          <span slot="next-nav">
            <svg
              class="page-arrow"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="22"
              height="22"
              viewBox="0 0 226 226"
              style="fill: #000000"
            >
              <g
                fill="none"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray=""
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style="mix-blend-mode: normal"
              >
                <path d="M0,226v-226h226v226z" fill="none"></path>
                <g fill="#b2b2b2">
                  <path
                    d="M143.19219,56.32344c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0l-52.96875,52.96875c-2.11875,2.11875 -2.11875,5.47344 0,7.41562l52.96875,52.96875c1.05937,1.05937 2.47188,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-49.26094,-49.26094l49.26094,-49.26094c2.11875,-2.11875 2.11875,-5.29687 0,-7.41563z"
                  ></path>
                </g>
              </g>
            </svg>
          </span>
        </pagination>
      </section>
    </section>
  </main>
</template>
<script>
import Product from "@/parts/Front/components/product/Product";
import pagination from "shetabit-laravel-vue-pagination";
import { BSkeletonImg, BSkeleton } from "bootstrap-vue";
import Loading from "@/parts/Front/components/shared/Loading";
import axios from "axios";
export default {
  name: "SalesCampaign",
  data() {
    return {
      flashes: null,
      page: this.$route.query.page ? this.$route.query.page : 1,
      loading: false,
      nextpage: false,
    };
  },

  components: {
    Product,
    pagination,
    BSkeletonImg,
    BSkeleton,
    Loading,
  },
  methods: {
    async request() {
      if (this.page == 1) {
        this.loading = true;
      } else if (this.page >= 2) {
        this.nextpage = true;
      }
      await axios.get(`/front/flashes?page=${this.page}`).then((res) => {
        this.flashes = res.data.data.flash;
        console.log(res.data.data.flash, "res.data");
      });
      this.loading = false;
      this.nextpage = false;
    },
    changePage() {
      this.page = this.$route.query.page;
      this.request();
    },
  },
  computed: {
    // flashes() {
    //   if (this.$store.getters["front/getHomeData"] != null) {
    //     return this.$store.getters["front/getHomeData"].flashes;
    //   } else {
    //     return null;
    //   }
    // },

    banners() {
      if (this.$store.getters["front/getHomeData"] != null) {
        let advertise = this.$store.getters["front/getHomeData"].advertise;
        return advertise;
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.request();
  },
};
</script>
<style scoped>
.loading-container {
  position: sticky;
  top: 50%;
  left: 50vw;
  transform: translate(-50%, -50%);
  width: 100px;
  background: var(--color-theme2);
  border-radius: 10px;
  padding: 10px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  margin-inline: auto;
}
.image-campaign {
  margin-bottom: 3rem;
  display: flex;
  width: 100%;
}

.image-campaign img {
  width: 100%;
}

.content-sales-campaign {
  margin-top: 3rem;
}

.content-sales-campaign-grid {
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

@media only screen and (max-width: 1200px) {
  .content-sales-campaign-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }
}

@media only screen and (max-width: 1024px) {
  .content-sales-campaign-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }
}

@media only screen and (max-width: 648px) {
  .content-sales-campaign-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .image-campaign {
    margin-bottom: 2rem;
  }
}
</style>
